import CompleteInspectionPages from './CompleteInspectionPages';

export default CompleteInspectionPages;
